import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import NormalDialog from "../../Dialog/NormalDialog";

// Custom Component
import useLoading from "../../Loading/useLoading";
import LockScreenLoading from "../../LockScreenLoading/LockScreenLoading";
import ConfirmDialog from "../../Dialog/ConfirmDialog";
import ToCirculationConfirmDialog from "../../Dialog/ToCirculationComfirmDialog";
import ReturnCommentDialog from "../../Dialog/ReturnCommentDialog";
import SaveWarnDialog from "../../Dialog/SaveWarnDialog";
import FullScreenDialog from "../../Dialog/FullScreenDialog";
import FilePreview from "../../FilePreview/FilePreview";
import Efiling from "../../../views/Efiling/Efiling.js";
import RFIRecipientForm from "./RFIRecipientForm";
import WebViewer from "../../WebViewer/WebViewer";

// RFI Section
import RFIMaster from "./rfiSection/RFIMaster";
import RFIComment from "./rfiSection/RFIComment";
import RFIDraftResponse from "./rfiSection/RFIDraftResponse";
import RFIResponse from "./rfiSection/RFIResponse";
import RFIResponseHistory from "./rfiSection/RFIResponseHistory";
import RFIAssignList from "./rfiSection/RFIAssignList";
import RFIReturnComment from "./rfiSection/RFIReturnComment";

import { webViewerSaveAnnotation } from "../../../global/webViewerSaveAnnotation";
// Custom Style
import { rfiDetailFormStyle } from "../../../styles/jss/components/RFI/rfiDetailFormStyle";

import {
  getRFIDetails,
  createRFI,
  updateRFI,
  insertRFIComment,
  insertRFIResponse,
  updateRFIResponse,
  getRfiStageList,
  updateRFIStage,
  updateRFISendFlag,
  updateRFIApproveStage,
  insertStageAction,
  transferRFItoEfiling,
} from "../../../dataSource/rfi";
import {
  getUser,
  getUserGroupType,
  getUserGroup,
} from "../../../dataSource/circulation";

import { getFile } from "../../../global/getPropertyInfo";

// Fetch Data
import {
  getPropertyDetail,
  getCompanyList,
  removePropertyFile,
  setPrimary,
  fileUpload,
  fileDownload,
  addFileProperty,
} from "../../../dataSource/fileManager";
import { sub } from "date-fns";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const store = require("store");

const RFIDetailsForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    setOpenDialog,
    isNew,
    rfiSeq,
    buildAlert,
    setTabValue,
    isSubCon,
    isInternal,
  } = props;
  // Use redux data
  const submissionRFIDetailRedux = useSelector(
    (state) => state.submissionRFIDetailRedux
  );
  const submissionRFIResponseRedux = useSelector(
    (state) => state.submissionRFIResponseRedux
  );
  const submissionRFICommentRedux = useSelector(
    (state) => state.submissionRFICommentRedux
  );

  const propertySeqRedux = useSelector((state) => state.propertySeqRedux);
  const userModulesRedux = useSelector((state) => state.userModulesRedux);

  // Loading
  const [getUserListLoading, getUserListShowLoading, getUserListHiddenLoading] =
    useLoading();
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [
    getGroupListLoading,
    getGroupListShowLoading,
    getGroupListHiddenLoading,
  ] = useLoading();
  const [getDetailsLoading, getDetailsShowLoading, getDetailsHiddenLoading] =
    useLoading();
  const [
    updateDetailsLoading,
    updateDetailsShowLoading,
    updateDetailsHiddenLoading,
  ] = useLoading();

  const [submissionResponseValue, setSubmissionResponseValue] = useState({
    companyName: "",
    from: "",
    response: "",
    type: "noted",
    messages: {
      parent_seq: 0,
      content: "",
      dms_property_seqs: [],
      attachments: [],
    },
  });
  const [propertySubject, setPropertySubject] = useState(null);
  const [reponseHistoryValue, setResponseHistoryValue] = useState({
    transmittal: [],
  });
  const [submissionCommentValue, setSubmissionCommentValue] = useState({
    rficomment: "",
    files: [],
  });
  const [rfiStageList, setRfiStageList] = useState([]);
  const [contentEditorValue, setContentEditorValue] = useState("");
  const [submissionValue, setSubmissionValue] = useState({
    request_date: null,
    drawing_ref: "",
    manual_ref_no: "",
    specification: "",
    location: "",
    anticipated_date: null,
    subject: "",
    content: "",
    recipients: {
      RESPONSIBLE: [],
      APPROVE: [],
      SECONDAPPROVER: [],
      THIRDAPPROVER: [],
      CONSULTANT: [],
      ARCHITECT: [],
      TO: [],
      CC: [],
      PM: [],
    },
    email: {
      to: [],
      cc: [],
    },
    category: [],
    is_draft: "Y",
    draft_rfi_seq: null,
    messages: {
      parent_seq: 0,
      content: "",
      dms_property_seqs: [],
      files: [],
    },
  });
  const [stageBody, setStageBody] = useState({});

  const [rfiDuplicate, setRfiDuplicate] = useState(false);
  const [emailErrors, setEmailErrors] = useState({ to: [], cc: [] });
  const [webViewProps, setWebViewProps] = useState(null);
  const [webViewerDocumentClose, setWebViewerDocumentClose] = useState(false);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const [returnCommentDialogOpen, setReturnCommentDialogOpen] = useState(false);
  const [returnCommentDialogData, setReturnCommentDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });

  const [rfiToCirculateDialogOpen, setRfiToCirculateDialogOpen] =
    useState(false);
  const [rfiToCirculateDialogData, setRfiToCirculateDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });

  const [filePreviewProperty, SetFilePreviewProperty] = useState(null);
  const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false);
  const [noneditfilePreviewDialogOpen, setFileNonEditPreviewDialogOpen] =
    useState(false);
  const [newCirculationDialogOpen, setNewCirculationDialogOpen] =
    useState(false);

  const [saveWarnDialogOpen, setSaveWarnDialogOpen] = useState(false);
  const [saveWarnDialogData, setSaveWarnDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    saveAction: "",
    dontSaveAction: "",
    cancelAction: "",
  });

  const [renewCircList, setRenewCircList] = useState(0);

  const [fileManagerDialogOpen, setFileManagerDialogOpen] = useState(false);
  const [draftfileManagerDialogOpen, setDraftFileManagerDialogOpen] =
    useState(false);
  const [transferRcptDialogOpen, setTransferRcptDialogOpen] = useState(false);
  const [buildRFIOpen, setBuildRfiOpen] = useState(false);
  const [editable, setEditable] = useState(false);
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [internalOnly, setInternalOnly] = useState(true);
  const [dialogName, setDialogName] = useState(null);
  const [recipientType, setRecipientType] = useState(null);
  const [userGroupType, setUserGroupType] = useState(null);
  const [internalUserList, setInternalUserList] = useState(null);
  const [externalUserList, setExternalUserList] = useState(null);
  const [userGroupList, setUserGroupList] = useState(null);
  const [userStageAction, setUserStageAction] = useState({
    IS_UPDATABLE: "N",
    IS_DETAIL_READABLE: "N",
    IS_APPROVABLE: "N",
    IS_CLOSABLE: "N",
    IS_RETURNABLE: "N",
    IS_VOIDABLE: "N",
    IS_COMMENTABLE: "N",
    IS_COMMENT_READABLE: "N",
    IS_RETURNCOMMENT_READABLE: "N",
    IS_RESPONDABLE: "N",
    IS_RESPONSE_READABLE: "N",
    IS_COMPLETABLE: "N",
    IS_SENDABLE: "N",
    IS_TRANSFERABLE: "N",
    IS_TRANSMITTABLE: "N",
    IS_APPROVABLE: "N",
    IS_ATTACHMENT_READABLE: "N",
  });

  const [loadingFinish, setLoadingFinish] = useState(false);
  const [fileUploadingProperty, setFileUploadingProperty] = useState([]);
  const [circulationSubject, setCirculationSubject] = useState("");
  const [presetSubject, setPresetSubject] = useState(null);
  const [presetFiles, setPresetFiles] = useState(null);
  const [presetResponseFiles, setPresetResponseFiles] = useState(null);
  const [presetDraftResponseFiles, setPresetDraftResponseFiles] =
    useState(null);

  const [leftResponsibleUserRcpt, setLeftResponsibleUserRcpt] = useState(null);
  const [rightResponsibleUserRcpt, setRightResponsibleUserRcpt] =
    useState(null);
  const [leftResponsibleGroupRcpt, setLeftResponsibleGroupRcpt] =
    useState(null);
  const [rightResponsibleGroupRcpt, setRightResponsibleGroupRcpt] =
    useState(null);

  const [tmpGroupList, setTmpGroupList] = useState(null);

  const [leftPMUserRcpt, setLeftPMUserRcpt] = useState(null);
  const [rightPMUserRcpt, setRightPMUserRcpt] = useState(null);
  const [leftPMGroupRcpt, setLeftPMGroupRcpt] = useState(null);
  const [rightPMGroupRcpt, setRightPMGroupRcpt] = useState(null);

  const [leftApproveUserRcpt, setLeftApproveUserRcpt] = useState(null);
  const [rightApproveUserRcpt, setRightApproveUserRcpt] = useState(null);
  const [leftApproveGroupRcpt, setLeftApproveGroupRcpt] = useState(null);
  const [rightApproveGroupRcpt, setRightApproveGroupRcpt] = useState(null);

  const [leftSecondApproveUserRcpt, setLeftSecondApproveUserRcpt] =
    useState(null);
  const [rightSecondApproveUserRcpt, setRightSecondApproveUserRcpt] =
    useState(null);
  const [leftSecondApproveGroupRcpt, setLeftSecondApproveGroupRcpt] =
    useState(null);
  const [rightSecondApproveGroupRcpt, setRightSecondApproveGroupRcpt] =
    useState(null);

  const [leftThirdApproveUserRcpt, setLeftThirdApproveUserRcpt] =
    useState(null);
  const [rightThirdApproveUserRcpt, setRightThirdApproveUserRcpt] =
    useState(null);
  const [leftThirdApproveGroupRcpt, setLeftThirdApproveGroupRcpt] =
    useState(null);
  const [rightThirdApproveGroupRcpt, setRightThirdApproveGroupRcpt] =
    useState(null);

  const [leftConsultantUserRcpt, setLeftConsultantUserRcpt] = useState(null);
  const [rightConsultantUserRcpt, setRightConsultantUserRcpt] = useState(null);
  const [leftConsultantGroupRcpt, setLeftConsultantGroupRcpt] = useState(null);
  const [rightConsultantGroupRcpt, setRightConsultantGroupRcpt] =
    useState(null);

  const [leftArchitectUserRcpt, setLeftArchitectUserRcpt] = useState(null);
  const [rightArchitectUserRcpt, setRightArchitectUserRcpt] = useState(null);
  const [leftArchitectGroupRcpt, setLeftArchitectGroupRcpt] = useState(null);
  const [rightArchitectGroupRcpt, setRightArchitectGroupRcpt] = useState(null);

  const [leftCcUserRcpt, setLeftCcUserRcpt] = useState(null);
  const [rightCcUserRcpt, setRightCcUserRcpt] = useState(null);
  const [leftCcGroupRcpt, setLeftCcGroupRcpt] = useState(null);
  const [rightCcGroupRcpt, setRightCcGroupRcpt] = useState(null);
  const [tmpResponseSeq, setTmpResponseSeq] = useState(null);

  const [leftToUserRcpt, setLeftToUserRcpt] = useState(null);
  const [rightToUserRcpt, setRightToUserRcpt] = useState(null);
  const [leftToGroupRcpt, setLeftToGroupRcpt] = useState(null);
  const [rightToGroupRcpt, setRightToGroupRcpt] = useState(null);

  const [removeRecipientArray, setRemoveRecipientArray] = useState({
    removeArr: [],
  });

  const [selectUserDialogOpen, setSelectUserDialogOpen] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [responsevalidationErrors, setResponseValidationErrors] = useState({});
  const [commentvalidationErrors, setCommentValidationErrors] = useState({});
  const [draftResponsevalidationErrors, setdraftResponsevalidationErrors] =
    useState({});

  const [removeResponseAtth, setRemoveResponseAtth] = useState({
    removeArr: [],
  });
  const [removeRFIAtt, setRemoveRFIAtt] = useState({ removeRFIArr: [] });

  const getRFIDetail = async () => {
    const response = await getRFIDetails(rfiSeq);
    setSubmissionValue(response.data);
    setContentEditorValue(response.data.content);

    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...response.data },
    });

    return response.data;
  };

  // Clear Data Storage
  const clearData = () => {
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: null,
    });
  };

  // Build Confirm Dialog
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  const rfiToCirculateDialogHandleOpen = (data) => {
    setRfiToCirculateDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
      rfi_seq: data.rfi_seq,
      ref_no: data.ref_no,
      transmittal: data.transmittal,
    });

    setRfiToCirculateDialogOpen(true);
  };

  const rfiToCirculateDialogHandleClose = () => {
    setRfiToCirculateDialogOpen(false);
  };

  // Build Return Comment Dialog
  const returnCommentDialogHandleOpen = (data) => {
    setReturnCommentDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      rfi_seq: data.rfi_seq,
      my_rcpt_type: data.my_rcpt_type,
      stageCode: data.stageCode,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setReturnCommentDialogOpen(true);
  };

  const returnCommentDialogHandleClose = () => {
    setReturnCommentDialogOpen(false);
  };

  // Save Dialog action
  const saveResponsetoDraftAction = (rfi_seq, response_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Save RFI Response to Draft",
      dialogContent: "Are you sure to save this response to draft?",
      confirmAction: () => saveResponseAction(rfi_seq, response_seq),
      cancelAction: postResponseCancelAction,
    });
  };

  const saveDraftResponsetoDraftAction = (rfi_seq, response_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Save Draft Response",
      dialogContent: "Are you sure to save this draft response?",
      confirmAction: () => saveDraftResponseAction(rfi_seq, response_seq),
      cancelAction: postResponseCancelAction,
    });
  };
  // Confirm Dialog action
  const postResponseConfirmAction = (rfi_seq, response_seq) => {
    if (responsevalidate()) {
      confirmDialogHandleOpen({
        dialogTitle: "Add new response of RFI",
        dialogContent: "Are you sure to post response?",
        confirmAction: () => postResponseAction(rfi_seq, response_seq),
        cancelAction: confirmDialogHandleClose,
      });
    }
  };

  const postDraftResponseConfirmAction = (rfi_seq, response_seq, validate) => {
    if (validate.from === "" && validate.companyName === "") {
      confirmDialogHandleOpen({
        dialogTitle: "Confirm draft response",
        dialogContent: "Are you sure to post response?",
        confirmAction: () => postDraftResponseAction(rfi_seq, response_seq),
        cancelAction: confirmDialogHandleClose,
      });
    }
  };

  const postRFIConfirmAction = () => {
    if (validate()) {
      if (emailErrors.to.length === 0 && emailErrors.cc.length === 0) {
        confirmDialogHandleOpen({
          dialogTitle: "Add new RFI",
          dialogContent: "Are you sure to submit rfi?",
          confirmAction: () => postRFIAction(),
          cancelAction: confirmDialogHandleClose,
        });
      }
    }
  };

  const editRFIConfirmAction = (rfi_seq) => {
    if (validate()) {
      if (emailErrors.to.length === 0 && emailErrors.cc.length === 0) {
        confirmDialogHandleOpen({
          dialogTitle: "Save the RFI",
          dialogContent: "Are you sure to save rfi?",
          confirmAction: () => editRFIAction(rfi_seq),
          cancelAction: confirmDialogHandleClose,
        });
      }
    }
  };
  const editRFIAction = (rfi_seq) => {
    confirmDialogHandleClose();
    let submissionUpdateBody = {
      request_date: submissionValue.request_date,
      drawing_ref: submissionValue.drawing_ref,
      specification: submissionValue.specification,
      location: submissionValue.location,
      anticipated_date: submissionValue.anticipated_date,
      subject: submissionValue.subject,
      manual_ref_no: submissionValue.manual_ref_no,
      content: submissionValue.content,
      recipients: submissionValue.recipients,
      category: submissionValue.category,
      messages: submissionValue.messages,
      is_draft: buildRFIOpen || submissionValue.is_draft === "N" ? "N" : "Y",
      removeAtthArr: removeRFIAtt.removeRFIArr,
      removeRecipientArr: removeRecipientArray.removeArr,
      email: submissionValue.email,
    };

    updateDetailsShowLoading();
    updateRFI(rfi_seq, submissionUpdateBody).then((res) => {
      updateDetailsHiddenLoading();
      window.location.reload();
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been created",
      });
      setOpenDialog(false);
      // setTabValue(0);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Post RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const sendRFIToExternalConfirmAction = (rfi_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Send RFI to external",
      dialogContent: "Are you sure to send rfi to external?",
      confirmAction: () => sendRFIToExternalAction(rfi_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const sendRFIToExternalAction = (rfi_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = "WAITINGREPLY";
    updateRFISendFlag(rfi_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been sent to external",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Send RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const approveRFIConfirmAction = (rfi_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Approve RFI",
      dialogContent: "Are you sure to approve rfi?",
      confirmAction: () => approveRFIAction(rfi_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const approveRFIAction = (rfi_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = submissionValue.stageCode;

    updateRFIApproveStage(rfi_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been approved",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Approve RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const completeRFIConfirmAction = (rfi_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Complete RFI",
      dialogContent: "Are you sure to complete rfi?",
      confirmAction: () => completeRFIAction(rfi_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const completeRFIAction = async (rfi_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = "COMPLETED";

    updateRFIStage(rfi_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been completed",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Complete RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
    await eFilngConfirmAction();
  };
  const closeRFIConfirmAction = (rfi_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Close RFI",
      dialogContent: "Are you sure to close rfi?",
      confirmAction: () => closeRFIAction(rfi_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };
  const closeRFIAction = (rfi_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = "CLOSED";

    updateRFIStage(rfi_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been closed",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Close RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };
  const voidRFIConfirmAction = (rfi_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Void RFI",
      dialogContent: "Are you sure to void rfi?",
      confirmAction: () => voidRFIAction(rfi_seq),
      cancelAction: confirmDialogHandleClose,
    });
  };
  const voidRFIAction = (rfi_seq) => {
    confirmDialogHandleClose();
    stageBody.stageCode = "VOIDED";

    updateRFIStage(rfi_seq, stageBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been voided",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Void RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const circulationHandleClose = () => {
    setOpenDialog(false);
  };

  const returnRFIConfirmAction = () => {
    returnCommentDialogHandleOpen({
      dialogTitle: "Return RFI",
      dialogContent: "Please leave return comment",
      rfi_seq: rfiSeq,
      my_rcpt_type: submissionValue.my_rcpt_type,
      stageCode: submissionValue.stageCode,
      // confirmAction: () => returnRFIAction(rfi_seq),
      cancelAction: returnCommentDialogHandleClose,
    });
  };

  // const returnRFIAction = (rfi_seq) => {
  //   returnCommentDialogHandleClose();
  //   stageBody.stageCode = "RETURNED";

  //   updateRFIStage(rfi_seq, stageBody).then((res) => {
  //     buildAlert({
  //       // Alert Type: success, info, warning, error
  //       type: "success",
  //       title: "Success Alert",
  //       content: "The rfi have been returned",
  //     });
  //     setOpenDialog(false);
  //     console.log(
  //       "*****************************************************************************"
  //     );
  //     console.log("System Module: RFI");
  //     console.log("Message: Return RFI Successful.");
  //     console.log(res);
  //     console.log(
  //       "*****************************************************************************"
  //     );
  //   });
  // };

  // Confirm Dialog action
  const postCommentConfirmAction = (rfi_seq, postFlag) => {
    if (postFlag) {
      confirmDialogHandleOpen({
        dialogTitle: "Add new comment of RFI",
        dialogContent: "Are you sure to post comment?",
        confirmAction: () => npm(rfi_seq),
        cancelAction: postCommentCancelAction,
      });
    }
  };

  // Main Action
  const fileUploadAction = (fileType, acceptedFilesPool) => {
    let UploadingSource = buildFileUploadingProperty(acceptedFilesPool);
    acceptedFilesPool.map((file) => {
      fileUpload(file).then((res) => {
        console.log(
          "*****************************************************************************"
        );
        console.log("Temporary upload File Successful");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
        UploadingSource = removeFileUploadingProperty(UploadingSource, file);
        // buildFileRecordFromHarddisk(fileType, res.data[0])
        buildFileRecord(fileType, res.data[0]);
      });
    });
  };

  const buildFileUploadingProperty = (fileUploadRecord) => {
    const res = [...fileUploadingProperty, ...fileUploadRecord];

    setFileUploadingProperty(res);
    dispatch({
      type: "ADD_FILE_UPLOADING_PROPERTY",
      data: res,
    });

    return res;
  };

  const removeFileUploadingProperty = (sourceRecords, key) => {
    if (sourceRecords) {
      const res = sourceRecords.filter((sourceRecord) => sourceRecord !== key);

      setFileUploadingProperty(res);
      dispatch({
        type: "ADD_FILE_UPLOADING_PROPERTY",
        data: res,
      });

      return res;
    }
  };

  const buildFileRecord = (fileType, fileUploadRecord) => {
    const val = { ...submissionValue };
    fileUploadRecord.modifydate = "";
    val.messages.files.push(fileUploadRecord);

    setSubmissionValue({ ...submissionValue, ...val });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, val },
    });
  };

  const draftResponseFileUploadAction = (
    fileType,
    acceptedFilesPool,
    response_seq
  ) => {
    let UploadingSource = buildFileUploadingProperty(acceptedFilesPool);
    acceptedFilesPool.map((file) => {
      fileUpload(file).then((res) => {
        console.log(
          "*****************************************************************************"
        );
        console.log("Temporary upload File Successful");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
        UploadingSource = removeFileUploadingProperty(UploadingSource, file);
        buildDraftresponseFileRecord(fileType, res.data[0], response_seq);
      });
    });
  };
  const buildDraftresponseFileRecord = (
    fileType,
    fileUploadRecord,
    response_seq
  ) => {
    const data = { ...submissionValue };
    fileUploadRecord.modifydate = "";

    data.draftMessages
      .filter((obj) => obj.response_seq === response_seq)[0]
      .attachments.push(fileUploadRecord);

    setSubmissionValue({ ...submissionValue, ...data });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, data },
    });
  };

  // Main Action
  const responseFileUploadAction = (fileType, acceptedFilesPool) => {
    let UploadingSource = buildFileUploadingProperty(acceptedFilesPool);
    acceptedFilesPool.map((file) => {
      fileUpload(file).then((res) => {
        console.log(
          "*****************************************************************************"
        );
        console.log("Temporary upload File Successful");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
        UploadingSource = removeFileUploadingProperty(UploadingSource, file);
        buildResponseFileRecord(fileType, res.data[0]);
      });
    });
  };
  const buildResponseFileRecord = (fileType, fileUploadRecord) => {
    const val = { ...submissionResponseValue };
    fileUploadRecord.modifydate = "";
    val.messages.attachments.push(fileUploadRecord);

    setSubmissionResponseValue({ ...submissionResponseValue, ...val });
    dispatch({
      type: "ADD_RFI_RESPONSE_SUBMISSION_VALUE",
      data: { ...submissionResponseValue, val },
    });
  };

  const postResponseCancelAction = () => {
    confirmDialogHandleClose();
  };

  const postCommentCancelAction = () => {
    confirmDialogHandleClose();
  };

  //Main RFI Action
  const postRFIAction = () => {
    confirmDialogHandleClose();
    submissionValue.is_draft = isInternal ? "N" : "Y";

    updateDetailsShowLoading();
    createRFI(submissionValue).then((res) => {
      updateDetailsHiddenLoading();
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been created",
      });
      setOpenDialog(false);
      setTabValue(0);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Post RFI Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const transferRFIAction = () => {
    let data = { ...submissionValue };
    data.recipients.TO = [];
    setSubmissionValue({ ...submissionValue, ...data });
    setTransferRcptDialogOpen(true);
  };

  const circulateAction = () => {
    rfiToCirculateDialogHandleOpen({
      dialogTitle: "Circulate this RFI",
      dialogContent: "Are you sure to circulate this RFI?",
      rfi_seq: rfiSeq,
      ref_no: submissionValue.ref_no,
      transmittal: reponseHistoryValue.transmittal,
      confirmAction: () => circulateConfirmAction(),
      cancelAction: rfiToCirculateDialogHandleClose,
    });
  };

  const circulateConfirmAction = () => {
    setRfiToCirculateDialogOpen(true);
  };

  const eFilingAction = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Save RFI To Efiling",
      dialogContent: "Are you sure to save this RFI to eFiling?",
      confirmAction: () => eFilngConfirmAction(),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const eFilngConfirmAction = async () => {
    try {
      let postBody = {
        rfi_seq: rfiSeq,
        transmittal: reponseHistoryValue.transmittal,
        ref_no: submissionValue.ref_no,
        subject: submissionValue.subject,
        targeted_site_user_seq:
          submissionValue.recipients.CONSULTANT[0].site_user_seq,
      };
      confirmDialogHandleClose();
      setLockScreenLoadingOpen(true);
      const response = await transferRFItoEfiling(postBody);
      setLockScreenLoadingOpen(false);
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The rfi have been transfered to eFiling",
      });
      setOpenDialog(false);
    } catch (err) {
      console.error(err);
    }
  };

  const getLeftAndRightRecipients = (userList, groupList, recipientType) => {
    let toLeftData = [];
    let toRightData = [];

    let keys = groupList && Object.keys(groupList);
    let ToLeftGroupData = {};
    let ToRightGroupdata = {};

    for (let j = 0; j < keys.length; j++) {
      let groupKey = keys[j];

      var object = {
        [groupKey]: [],
        recipientType: recipientType,
      };
      ToLeftGroupData = { ...ToLeftGroupData, ...object };
      ToRightGroupdata = { ...ToRightGroupdata, ...object };
    }

    for (let i = 0; i < submissionValue.recipients[recipientType].length; i++) {
      let internalUser = toLeftData.length === 0 ? userList : toLeftData;
      if (submissionValue.recipients[recipientType][i].rcpt_type === "USER") {
        toLeftData =
          userList.length > 0 &&
          internalUser.filter(
            (obj) =>
              obj.site_user_seq !==
              submissionValue.recipients[recipientType][i].site_user_seq
          );
        let ToRight =
          userList.length > 0 &&
          userList.find(
            (obj) =>
              obj.site_user_seq ===
              submissionValue.recipients[recipientType][i].site_user_seq
          );
        let obj = {
          rcpt_seq: submissionValue.recipients[recipientType][i].rcpt_seq,
        };
        ToRight = { ...ToRight, ...obj };
        toRightData.push(ToRight);
      }

      if (
        submissionValue.recipients[recipientType][i].rcpt_type === "USERGROUP"
      ) {
        for (const [key, value] of Object.entries(groupList)) {
          groupList[key] =
            ToLeftGroupData[key].length > 0
              ? ToLeftGroupData[key]
              : groupList[key];

          if (submissionValue.recipients[recipientType][i].type_seq == key) {
            ToLeftGroupData[key] = groupList[key].filter(
              (obj) =>
                obj.group_seq !==
                submissionValue.recipients[recipientType][i].group_seq
            );
            let ToRightGroup =
              groupList[key].find(
                (obj) =>
                  obj.group_seq ===
                  submissionValue.recipients[recipientType][i].group_seq
              ) !== undefined
                ? groupList[key].find(
                    (obj) =>
                      obj.group_seq ===
                      submissionValue.recipients[recipientType][i].group_seq
                  )
                : submissionValue.recipients[recipientType][i];
            let obj = {
              is_attachment_readable: "Y",
              rcpt_type: "USERGROUP",

              rcpt_seq: submissionValue.recipients[recipientType][i].rcpt_seq,
              group_name:
                submissionValue.recipients[recipientType][i].rcpt_name,
            };
            ToRightGroup = { ...ToRightGroup, ...obj };

            ToRightGroupdata[key].push(ToRightGroup);

            let data = { ...submissionValue };
            submissionValue.recipients[recipientType][i] = ToRightGroup;
            setSubmissionValue({ ...submissionValue, ...data });
          }
        }
      }
    }
    let dataList = {
      left: toLeftData,
      right: toRightData,
      leftGroup: ToLeftGroupData,
      rightGroup: ToRightGroupdata,
    };
    return dataList;
  };

  const updateRFIAction = () => {
    setEditable(true);

    let responseObj = {
      recipientType: "RESPONSIBLE",
    };
    let responseGroupList = { ...userGroupList, ...responseObj };
    let responsibleData = getLeftAndRightRecipients(
      internalUserList,
      responseGroupList,
      "RESPONSIBLE"
    );

    setLeftResponsibleUserRcpt(responsibleData.left);
    setRightResponsibleUserRcpt(responsibleData.right);
    setLeftResponsibleGroupRcpt(responsibleData.leftGroup);
    setRightResponsibleGroupRcpt(responsibleData.rightGroup);

    let pmObj = {
      recipientType: "PM",
    };
    let pmGroupList = { ...userGroupList, ...pmObj };
    let pmData = getLeftAndRightRecipients(internalUserList, pmGroupList, "PM");

    setLeftPMUserRcpt(pmData.left);
    setRightPMUserRcpt(pmData.right);
    setLeftPMGroupRcpt(pmData.leftGroup);
    setRightPMGroupRcpt(pmData.rightGroup);

    let approveObj = {
      recipientType: "APPROVE",
    };
    let approveGroupList = { ...userGroupList, ...approveObj };
    let approveData = getLeftAndRightRecipients(
      internalUserList,
      approveGroupList,
      "APPROVE"
    );
    setLeftApproveUserRcpt(approveData.left);
    setRightApproveUserRcpt(approveData.right);
    setLeftApproveGroupRcpt(approveData.leftGroup);
    setRightApproveGroupRcpt(approveData.rightGroup);

    let secondApproverObj = {
      recipientType: "SECONDAPPROVER",
    };
    let secondApproverGroupList = { ...userGroupList, ...secondApproverObj };
    let secondApproverData = getLeftAndRightRecipients(
      internalUserList,
      secondApproverGroupList,
      "SECONDAPPROVER"
    );
    setLeftSecondApproveUserRcpt(secondApproverData.left);
    setRightSecondApproveUserRcpt(secondApproverData.right);
    setLeftSecondApproveGroupRcpt(secondApproverData.leftGroup);
    setRightSecondApproveGroupRcpt(secondApproverData.rightGroup);

    let thirdapproverObj = {
      recipientType: "THIRDAPPROVER",
    };
    let thirdapproverGroupList = { ...userGroupList, ...thirdapproverObj };
    let thirdapproverData = getLeftAndRightRecipients(
      internalUserList,
      thirdapproverGroupList,
      "THIRDAPPROVER"
    );
    setLeftThirdApproveUserRcpt(thirdapproverData.left);
    setRightThirdApproveUserRcpt(thirdapproverData.right);
    setLeftThirdApproveGroupRcpt(thirdapproverData.leftGroup);
    setRightThirdApproveGroupRcpt(thirdapproverData.rightGroup);

    let consultantObj = {
      recipientType: "consultant",
    };
    let consultantGroupList = { ...userGroupList, ...consultantObj };
    let consultantData = getLeftAndRightRecipients(
      externalUserList,
      consultantGroupList,
      "CONSULTANT"
    );
    setLeftConsultantUserRcpt(consultantData.left);
    setRightConsultantUserRcpt(consultantData.right);
    setLeftConsultantGroupRcpt(consultantData.leftGroup);
    setRightConsultantGroupRcpt(consultantData.rightGroup);

    let architectObj = {
      recipientType: "architect",
    };
    let architectGroupList = { ...userGroupList, ...architectObj };
    let architectData = getLeftAndRightRecipients(
      externalUserList,
      architectGroupList,
      "ARCHITECT"
    );
    setLeftArchitectUserRcpt(architectData.left);
    setRightArchitectUserRcpt(architectData.right);
    setLeftArchitectGroupRcpt(architectData.leftGroup);
    setRightArchitectGroupRcpt(architectData.rightGroup);

    let CcObj = {
      recipientType: "CC",
    };
    let CcGroupList = { ...userGroupList, ...CcObj };
    let list = externalUserList.concat(internalUserList);

    let CcData = getLeftAndRightRecipients(list, CcGroupList, "CC");
    setLeftCcUserRcpt(CcData.left);
    setRightCcUserRcpt(CcData.right);
    setLeftCcGroupRcpt(CcData.leftGroup);
    setRightCcGroupRcpt(CcData.rightGroup);

    let data = { ...submissionValue };
    data.messages.files = submissionValue.rfi_attachments;
    setSubmissionValue({ ...submissionValue, ...data });
  };

  const buildRFIAction = () => {
    let data = { ...submissionValue };
    data.recipients.RESPONSIBLE = [];
    data.recipients.CONSULTANT = [];
    data.recipients.APPROVE = [];
    data.recipients.ARCHITECT = [];
    data.recipients.CC = [];
    data.messages.files = submissionValue.rfi_attachments;
    setSubmissionValue({ ...submissionValue, ...data });
    setBuildRfiOpen(true);
    setEditable(true);
  };

  // Main Response Action
  const postResponseAction = (rfi_seq, response_seq) => {
    confirmDialogHandleClose();
    submissionResponseValue.is_draft = "N";

    if (submissionValue.my_rcpt_type[0]["rcpt_category"] === "CONSULTANT") {
      submissionResponseValue.stageCode = "CONSULTANTREPLIED";
    } else if (
      submissionValue.my_rcpt_type[0]["rcpt_category"] === "ARCHITECT"
    ) {
      submissionResponseValue.stageCode = "ARCHITECTREPLIED";
    } else {
      submissionResponseValue.stageCode = "REPLIED";
    }

    if (submissionResponseValue.type !== "givecomment") {
      submissionResponseValue.content = "";
      submissionResponseValue.messages.attachments = [];
    }

    insertRFIResponse(rfi_seq, response_seq, submissionResponseValue).then(
      (res) => {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The Response have been posted",
        });
        setOpenDialog(false);
        console.log(
          "*****************************************************************************"
        );
        console.log("System Module: RFI");
        console.log("Message: Post Response Successful.");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
      }
    );
  };

  const postDraftResponseAction = (rfi_seq, response_seq) => {
    confirmDialogHandleClose();

    let submissionBody = submissionValue.draftMessages.filter(
      (obj) => obj.response_seq === response_seq
    )[0];
    if (submissionValue.my_rcpt_type[0]["rcpt_category"] === "CONSULTANT") {
      submissionBody.stageCode = "CONSULTANTREPLIED";
    } else if (
      submissionValue.my_rcpt_type[0]["rcpt_category"] === "ARCHITECT"
    ) {
      submissionBody.stageCode = "ARCHITECTREPLIED";
    } else {
      submissionBody.stageCode = "REPLIED";
    }

    let removeAtthArr = [];
    for (const removeBody of removeResponseAtth.removeArr) {
      if (removeBody.r_seq === response_seq) {
        removeAtthArr.push(removeBody.atth_seq);
      }
    }
    if (submissionBody.type !== "givecomment") {
      for (const removeAtth of submissionBody.attachments) {
        removeAtthArr.push(removeAtth.atth_seq);
      }
      submissionBody.attachments = [];
      submissionBody.content = "";
    }
    submissionBody.is_draft = "N";
    submissionBody.removeAtthArr = removeAtthArr;

    updateRFIResponse(rfi_seq, response_seq, submissionBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The Response have been posted",
      });

      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Post Response Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };
  const saveResponseAction = (rfi_seq, response_seq) => {
    confirmDialogHandleClose();
    submissionResponseValue.is_draft = "Y";
    if (submissionResponseValue.type !== "givecomment") {
      submissionResponseValue.content = "";
      submissionResponseValue.messages.attachments = [];
    }
    insertRFIResponse(rfi_seq, response_seq, submissionResponseValue).then(
      (res) => {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The Response have been saved",
        });
        setOpenDialog(false);

        console.log(
          "*****************************************************************************"
        );
        console.log("System Module: RFI");
        console.log("Message: Save Response Successful.");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
      }
    );
  };

  const saveDraftResponseAction = (rfi_seq, response_seq) => {
    confirmDialogHandleClose();
    let submissionBody = submissionValue.draftMessages.filter(
      (obj) => obj.response_seq === response_seq
    )[0];
    let removeAtthArr = [];
    for (const removeBody of removeResponseAtth.removeArr) {
      if (removeBody.r_seq === response_seq) {
        removeAtthArr.push(removeBody.atth_seq);
      }
    }
    if (submissionBody.type !== "givecomment") {
      for (const removeAtth of submissionBody.attachments) {
        removeAtthArr.push(removeAtth.atth_seq);
      }
      submissionBody.attachments = [];
      submissionBody.content = "";
    }
    submissionBody.is_draft = "Y";
    submissionBody.removeAtthArr = removeAtthArr;

    updateRFIResponse(rfi_seq, response_seq, submissionBody).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The Response have been saved",
      });
      setOpenDialog(false);

      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Save Response Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
  };
  // Main Comment Action
  const npm = (rfi_seq) => {
    confirmDialogHandleClose();
    submissionRFICommentRedux.stageCode = "COMMENTED";
    insertRFIComment(rfi_seq, submissionRFICommentRedux).then((res) => {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "success",
        title: "Success Alert",
        content: "The comment have been posted",
      });
      setOpenDialog(false);
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: RFI");
      console.log("Message: Post Comment Successful.");
      console.log(res);
      console.log(
        "*****************************************************************************"
      );
    });
    // console.log(submissionRFICommentRedux);
  };

  const handleRecipientClipClick = (popoverId) => (event) => {
    setOpenPopoverId(popoverId);
    setAnchorEl(event.currentTarget);
  };

  const handleRecipientClipClose = () => {
    setOpenPopoverId(null);
    setAnchorEl(null);
  };

  const viewFileAction = (fileCat, fileSeq, filename) => {
    SetFilePreviewProperty({
      fileCategory: fileCat,
      fileSequence: fileSeq,
      filename: filename,
    });

    filePreviewDialogHandleOpen();
  };

  const noneditViewFileAction = (fileCat, fileSeq, filename) => {
    setWebViewProps({
      file_cat: fileCat,
      file_ref: fileSeq,
      file_name: filename,
      from: "API",
      autoLoading: true,
    });

    fileNonEditPreviewDialogHandleOpen();
  };

  const removeResponseFileAction = (fileRecord) => {
    let result;
    let data = { ...submissionResponseValue };

    result = [...submissionResponseValue.messages.attachments].filter(
      (res) => res !== fileRecord
    );
    data.messages.attachments = result;

    setSubmissionResponseValue({ ...submissionResponseValue, ...data });
    dispatch({
      type: "ADD_RFI_RESPONSE_SUBMISSION_VALUE",
      data: { ...submissionResponseValue, ...data },
    });

    confirmDialogHandleClose();
  };

  const removeDraftResponseFileAction = (fileRecord, response_seq) => {
    let result;
    let data = { ...submissionValue };
    let removeAtthSeq = { ...removeResponseAtth };

    result = [
      ...submissionValue.draftMessages.filter(
        (obj) => obj.response_seq === response_seq
      )[0].attachments,
    ].filter((res) => res !== fileRecord);

    data.draftMessages.filter(
      (obj) => obj.response_seq === response_seq
    )[0].attachments = result;

    if (fileRecord.atth_seq !== undefined) {
      removeResponseAtth.removeArr.push({
        r_seq: response_seq,
        atth_seq: fileRecord.atth_seq,
      });
    }

    setSubmissionValue({ ...submissionValue, ...data });
    setRemoveResponseAtth({ ...removeResponseAtth, ...removeAtthSeq });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });

    confirmDialogHandleClose();
  };
  const removeFileAction = (fileRecord) => {
    let result;
    let data = { ...submissionValue };
    let removeAtthSeq = { ...removeRFIAtt };

    if (fileRecord.atth_seq !== undefined) {
      removeRFIAtt.removeRFIArr.push(fileRecord.atth_seq);
    }

    result = [...submissionValue.messages.files].filter(
      (res) => res !== fileRecord
    );
    data.messages.files = result;

    setSubmissionValue({ ...submissionValue, ...data });
    setRemoveRFIAtt({ ...removeRFIAtt, ...removeAtthSeq });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });

    confirmDialogHandleClose();
  };

  const removeFileConfirmAction = (fileRecord) => {
    confirmDialogHandleOpen({
      dialogTitle: "RFI attachment file remove",
      dialogContent: "Are you sure to remove the attachment file?",
      confirmAction: () => removeFileAction(fileRecord),
      cancelAction: removeFileCancelAction,
    });
  };

  const removeResponseFileConfirmAction = (fileRecord) => {
    confirmDialogHandleOpen({
      dialogTitle: "Respopnse attachment file remove",
      dialogContent: "Are you sure to remove the attachment file?",
      confirmAction: () => removeResponseFileAction(fileRecord),
      cancelAction: removeFileCancelAction,
    });
  };

  const removeDraftResponseFileConfirmAction = (fileRecord, response_seq) => {
    confirmDialogHandleOpen({
      dialogTitle: "Respopnse attachment file remove",
      dialogContent: "Are you sure to remove the attachment file?",
      confirmAction: () =>
        removeDraftResponseFileAction(fileRecord, response_seq),
      cancelAction: removeFileCancelAction,
    });
  };

  const removeFileCancelAction = () => {
    confirmDialogHandleClose();
  };

  const filePreviewDialogHandleOpen = () => {
    setFilePreviewDialogOpen(true);
  };

  const fileNonEditPreviewDialogHandleOpen = () => {
    setFileNonEditPreviewDialogOpen(true);
  };

  const filePreviewDialogHandleClose = () => {
    if (!store.get("annotActive")) {
      setFilePreviewDialogOpen(false);
    } else {
      alertSaveActionHandleOpen();
    }
  };

  const noneditfilePreviewDialogHandleClose = () => {
    setFileNonEditPreviewDialogOpen(false);
  };
  // Build Save Warn Dialog
  const saveWarnDialogHandleOpen = (data) => {
    setSaveWarnDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      saveAction: data.saveAction,
      dontSaveAction: data.dontSaveAction,
      cancelAction: data.cancelAction,
    });
    setSaveWarnDialogOpen(true);
  };

  const saveWarnDialogHandleClose = () => {
    setSaveWarnDialogOpen(false);
  };
  const alertSaveActionHandleOpen = () => {
    saveWarnDialogHandleOpen({
      dialogTitle: "Annotation Change Warning",
      dialogContent: "Do you want to save the change of annotation.",
      saveAction: alertSaveAnnotation,
      dontSaveAction: alertDontSaveAnnotation,
      cancelAction: alertSaveActionHandleClose,
    });
  };

  const alertSaveActionHandleClose = () => {
    saveWarnDialogHandleClose();
  };

  const alertSaveAnnotation = () => {
    annotationSaveAction();

    alertSaveActionHandleClose();
    setFilePreviewDialogOpen(false);
  };

  const alertDontSaveAnnotation = () => {
    alertSaveActionHandleClose();
    setFilePreviewDialogOpen(false);
  };

  //File Manager
  const fileManagerDialogHandleOpen = () => {
    setFileManagerDialogOpen(true);
  };

  const draftfileManagerDialogHandleOpen = (response_seq) => {
    setTmpResponseSeq(response_seq);
    setDraftFileManagerDialogOpen(true);
  };

  // Dialog Button Function
  const fileManagerFileSelected = async () => {
    if (propertySeqRedux === null) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Not any file choice, Please choice the file first.",
      });

      return;
    }

    if (propertySeqRedux.length === 0) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Not any file choice, Please choice the file first.",
      });

      return;
    }

    setPresetFiles(await getFile(propertySeqRedux));
    setPresetResponseFiles(await getFile(propertySeqRedux));

    fileManagerDialogHandleClose();
  };

  const draftfileManagerFileSelected = async () => {
    if (propertySeqRedux === null) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Not any file choice, Please choice the file first.",
      });

      return;
    }

    if (propertySeqRedux.length === 0) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Not any file choice, Please choice the file first.",
      });

      return;
    }

    setPresetDraftResponseFiles(await getFile(propertySeqRedux));

    draftfileManagerDialogHandleClose();
  };
  // Clear Data
  const clearFileChoice = () => {
    dispatch({
      type: "FILE_SELECT",
      data: null,
    });
  };

  const fileManagerDialogHandleClose = () => {
    clearFileChoice();
    setFileManagerDialogOpen(false);
  };

  const draftfileManagerDialogHandleClose = () => {
    clearFileChoice();
    setDraftFileManagerDialogOpen(false);
    setTmpResponseSeq(null);
  };

  // Handle Dialog open and close
  const selectRcptDialogHandleOpen = (dialogOpenName, type) => {
    setRecipientType(type);
    setDialogName(dialogOpenName);
    setSelectUserDialogOpen(true);
  };

  const selectRcptDialogHandleClose = () => {
    setRecipientType(null);
    setSelectUserDialogOpen(false);
  };

  // Dialog Button
  const fileManagerDialogBtn = [
    {
      buttonName: "OK",
      buttonFunction: fileManagerFileSelected,
      chooseFile: false,
    },
  ];

  // Dialog Button
  const draftfileManagerDialogBtn = [
    {
      buttonName: "OK",
      buttonFunction: draftfileManagerFileSelected,
      chooseFile: false,
    },
  ];
  const recipientDialogBtn = [
    {
      buttonName: "Close",
      buttonFunction: selectRcptDialogHandleClose,
      chooseFile: false,
    },
  ];

  const reciptentChipAdd = (type, recipientRec) => {
    let tempRecipients = {
      RESPONSIBLE: [...submissionValue.recipients.RESPONSIBLE],
      APPROVE: [...submissionValue.recipients.APPROVE],
      SECONDAPPROVER: [...submissionValue.recipients.SECONDAPPROVER],
      THIRDAPPROVER: [...submissionValue.recipients.THIRDAPPROVER],
      CONSULTANT: [...submissionValue.recipients.CONSULTANT],
      ARCHITECT: [...submissionValue.recipients.ARCHITECT],
      TO: [...submissionValue.recipients.TO],
      CC: [...submissionValue.recipients.CC],
      PM: [...submissionValue.recipients.PM],
    };

    if (type === "USER") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].push({
            rcpt_type: "USER", // USER, USERGROUP
            site_user_seq: res.site_user_seq,
            fullname: res.fullname,
            is_attachment_readable: "Y",
          });
        });
      }
    } else if (type === "GROUP") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].push({
            rcpt_type: "USERGROUP", // USER, USERGROUP
            type_seq: res.type_seq,
            group_seq: res.group_seq,
            group_name: res.group_name,
            group_members: res.group_members,
            is_attachment_readable: "Y",
          });
        });
      }
    }

    setSubmissionValue({ ...submissionValue, recipients: tempRecipients });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, recipients: tempRecipients },
    });
    if (
      (validationErrors.RESPONSIBLE && validationErrors.RESPONSIBLE !== "") ||
      (validationErrors.APPROVE && validationErrors.APPROVE !== "") ||
      (validationErrors.CONSULTANT && validationErrors.CONSULTANT !== "") ||
      (validationErrors.PM && validationErrors.PM !== "") ||
      (validationErrors.TO && validationErrors.TO !== "")
        ? true
        : false
    ) {
      validate({ ...submissionValue, recipients: tempRecipients });
    }
  };

  const reciptentChipRemove = (type, recipientRec) => {
    let tempRecipients = {
      RESPONSIBLE: [...submissionValue.recipients.RESPONSIBLE],
      APPROVE: [...submissionValue.recipients.APPROVE],
      SECONDAPPROVER: [...submissionValue.recipients.SECONDAPPROVER],
      THIRDAPPROVER: [...submissionValue.recipients.THIRDAPPROVER],
      CONSULTANT: [...submissionValue.recipients.CONSULTANT],
      ARCHITECT: [...submissionValue.recipients.ARCHITECT],
      TO: [...submissionValue.recipients.TO],
      CC: [...submissionValue.recipients.CC],
      PM: [...submissionValue.recipients.PM],
    };

    if (type === "USER") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].map((data, index) => {
            if (res.site_user_seq === data.site_user_seq) {
              tempRecipients[recipientType].splice(index, 1);
            }
          });
        });
      }
    } else if (type === "GROUP") {
      if (recipientRec !== null) {
        recipientRec.map((res) => {
          tempRecipients[recipientType].map((data, index) => {
            if (res.group_seq === data.group_seq) {
              tempRecipients[recipientType].splice(index, 1);
            }
          });
        });
      }
    }

    let data = { ...removeRecipientArray };
    data.removeArr.push(recipientRec[0].rcpt_seq);
    setRemoveRecipientArray({ ...removeRecipientArray, data });
    setSubmissionValue({ ...submissionValue, recipients: tempRecipients });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, recipients: tempRecipients },
    });
  };

  // Get Data
  const getUserListAction = () => {
    getUserListShowLoading();

    getUser(!internalOnly).then((res) => {
      let externalList = res.data.map((obj) => ({
        ...obj,
        userType: "external",
      }));
      setExternalUserList(externalList);
      dispatch({
        type: "ADD_EXTERNAL_USER_LIST",
        data: res.data,
      });
      getUserListHiddenLoading();
    });
    getUser(internalOnly).then((res) => {
      let internalList = res.data.map((obj) => ({
        ...obj,
        userType: "internal",
      }));
      setInternalUserList(internalList);
      dispatch({
        type: "ADD_INTERNAL_USER_LIST",
        data: res.data,
      });
      getUserListHiddenLoading();
    });
  };

  const getGroupListAction = (groupTypeList) => {
    getGroupListShowLoading();

    let tempLeftGroupList = {};
    let tempRightGroupList = {};
    // let groupTypeListSanfield = [
    //   { type_seq: 2, type_name: "SANFIELD GLOBAL GROUP" },
    // ];
    if (groupTypeList !== null) {
      groupTypeList.map((type) => {
        getUserGroup(type.type_seq).then((res) => {
          tempLeftGroupList[type.type_seq] = res.data;
          tempRightGroupList[type.type_seq] = [];

          setLeftCcGroupRcpt(tempLeftGroupList);
          setRightCcGroupRcpt(tempRightGroupList);
          setLeftPMGroupRcpt(tempLeftGroupList);
          setRightPMGroupRcpt(tempRightGroupList);
          setLeftResponsibleGroupRcpt(tempLeftGroupList);
          setRightResponsibleGroupRcpt(tempRightGroupList);
          setLeftApproveGroupRcpt(tempLeftGroupList);
          setRightApproveGroupRcpt(tempRightGroupList);
          setLeftSecondApproveGroupRcpt(tempLeftGroupList);
          setRightSecondApproveGroupRcpt(tempRightGroupList);
          setLeftThirdApproveGroupRcpt(tempLeftGroupList);
          setRightThirdApproveGroupRcpt(tempRightGroupList);
          setLeftConsultantGroupRcpt(tempLeftGroupList);
          setRightConsultantGroupRcpt(tempRightGroupList);
          setLeftArchitectGroupRcpt(tempLeftGroupList);
          setRightArchitectGroupRcpt(tempRightGroupList);
          setLeftToGroupRcpt(tempLeftGroupList);
          setRightToGroupRcpt(tempRightGroupList);
          setTmpGroupList(tempRightGroupList);

          setUserGroupList(tempLeftGroupList);
          dispatch({
            type: "ADD_USER_GROUP_LIST",
            data: tempLeftGroupList,
          });

          getGroupListHiddenLoading();
        });
      });
    }
  };

  const removeRecipientAction = (recipientType, typeSeq, removeRec) => {
    removeRecipient(recipientType, removeRec);

    moveTransferListData(recipientType, typeSeq, removeRec);
  };
  const removeRecipient = (recipientType, removeRec) => {
    let result = {
      RESPONSIBLE: [...submissionValue.recipients.RESPONSIBLE],
      APPROVE: [...submissionValue.recipients.APPROVE],
      SECONDAPPROVER: [...submissionValue.recipients.SECONDAPPROVER],
      THIRDAPPROVER: [...submissionValue.recipients.THIRDAPPROVER],
      CONSULTANT: [...submissionValue.recipients.CONSULTANT],
      ARCHITECT: [...submissionValue.recipients.ARCHITECT],
      TO: [...submissionValue.recipients.TO],
      CC: [...submissionValue.recipients.CC],
      PM: [...submissionValue.recipients.PM],
    };

    result[recipientType] = submissionValue.recipients[recipientType].filter(
      (rec) => rec !== removeRec
    );

    if (result["APPROVE"].length === 0) {
      result["SECONDAPPROVER"] = [];
      result["THIRDAPPROVER"] = [];
      setRightSecondApproveUserRcpt([]);
      setRightSecondApproveGroupRcpt(tmpGroupList);
      setRightThirdApproveUserRcpt([]);
      setRightThirdApproveGroupRcpt(tmpGroupList);
    }
    if (result["SECONDAPPROVER"].length === 0) {
      result["THIRDAPPROVER"] = [];
      setRightThirdApproveUserRcpt([]);
      setRightThirdApproveGroupRcpt(tmpGroupList);
    }

    let data = { ...removeRecipientArray };
    data.removeArr.push(removeRec.rcpt_seq);
    setRemoveRecipientArray({ ...removeRecipientArray, data });
    setSubmissionValue({ ...submissionValue, recipients: result });

    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, recipients: result },
    });
  };

  const moveTransferListData = (recipientType, typeSeq, removeRec) => {
    let groupRightResult =
      recipientType === "TO"
        ? { ...rightToGroupRcpt }
        : recipientType === "CC"
        ? { ...rightCcGroupRcpt }
        : recipientType === "PM"
        ? { ...rightPMGroupRcpt }
        : recipientType === "RESPONSIBLE"
        ? { ...rightResponsibleGroupRcpt }
        : recipientType === "APPROVE"
        ? { ...rightApproveGroupRcpt }
        : recipientType === "SECONDAPPROVER"
        ? { ...rightSecondApproveGroupRcpt }
        : recipientType === "THIRDAPPROVER"
        ? { ...rightThirdApproveGroupRcpt }
        : recipientType === "CONSULTANT"
        ? { ...rightConsultantGroupRcpt }
        : recipientType === "ARCHITECT"
        ? { ...rightArchitectGroupRcpt }
        : [];
    let groupLeftResult =
      recipientType === "TO"
        ? { ...leftToGroupRcpt }
        : recipientType === "CC"
        ? { ...leftCcGroupRcpt }
        : recipientType === "PM"
        ? { ...leftPMGroupRcpt }
        : recipientType === "RESPONSIBLE"
        ? { ...leftResponsibleGroupRcpt }
        : recipientType === "APPROVE"
        ? { ...leftApproveGroupRcpt }
        : recipientType === "SECONDAPPROVER"
        ? { ...leftSecondApproveGroupRcpt }
        : recipientType === "THIRDAPPROVER"
        ? { ...leftThirdApproveGroupRcpt }
        : recipientType === "CONSULTANT"
        ? { ...leftConsultantGroupRcpt }
        : recipientType === "ARCHITECT"
        ? { ...leftArchitectGroupRcpt }
        : [];
    if (removeRec.rcpt_type === "USER") {
      if (recipientType === "TO") {
        setRightToUserRcpt(
          rightToUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftToUserRcpt([
          ...leftToUserRcpt,
          ...rightToUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "CC") {
        setRightCcUserRcpt(
          rightCcUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftCcUserRcpt([
          ...leftCcUserRcpt,
          ...rightCcUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "RESPONSIBLE") {
        setRightResponsibleUserRcpt(
          rightResponsibleUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftResponsibleUserRcpt([
          ...leftResponsibleUserRcpt,
          ...rightResponsibleUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "APPROVE") {
        setRightApproveUserRcpt(
          rightApproveUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftApproveUserRcpt([
          ...leftApproveUserRcpt,
          ...rightApproveUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "PM") {
        setRightPMUserRcpt(
          rightPMUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftPMUserRcpt([
          ...leftPMUserRcpt,
          ...rightPMUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "SECONDAPPROVER") {
        setRightSecondApproveUserRcpt(
          rightSecondApproveUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftSecondApproveUserRcpt([
          ...leftSecondApproveUserRcpt,
          ...rightSecondApproveUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "THIRDAPPROVER") {
        setRightThirdApproveUserRcpt(
          rightThirdApproveUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftThirdApproveUserRcpt([
          ...leftThirdApproveUserRcpt,
          ...rightThirdApproveUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "CONSULTANT") {
        setRightConsultantUserRcpt(
          rightConsultantUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftConsultantUserRcpt([
          ...leftConsultantUserRcpt,
          ...rightConsultantUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      } else if (recipientType === "ARCHITECT") {
        setRightArchitectUserRcpt(
          rightArchitectUserRcpt.filter(
            (rec) => rec.site_user_seq !== removeRec.site_user_seq
          )
        );
        setLeftArchitectUserRcpt([
          ...leftArchitectUserRcpt,
          ...rightArchitectUserRcpt.filter(
            (rec) => rec.site_user_seq === removeRec.site_user_seq
          ),
        ]);
      }
    } else if (removeRec.rcpt_type === "USERGROUP") {
      if (recipientType === "TO") {
        groupRightResult[typeSeq] = rightToGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightToGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightToGroupRcpt({ ...rightToGroupRcpt, ...groupRightResult });
        setLeftToGroupRcpt({ ...leftToGroupRcpt, ...groupLeftResult });
      } else if (recipientType === "CC") {
        groupRightResult[typeSeq] = rightCcGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightCcGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightCcGroupRcpt({ ...rightCcGroupRcpt, ...groupRightResult });
        setLeftCcGroupRcpt({ ...leftCcGroupRcpt, ...groupLeftResult });
      } else if (recipientType === "PM") {
        groupRightResult[typeSeq] = rightPMGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightPMGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightPMGroupRcpt({ ...rightPMGroupRcpt, ...groupRightResult });
        setLeftPMGroupRcpt({ ...leftPMGroupRcpt, ...groupLeftResult });
      } else if (recipientType === "RESPONSIBLE") {
        groupRightResult[typeSeq] = rightResponsibleGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightResponsibleGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightResponsibleGroupRcpt({
          ...rightResponsibleGroupRcpt,
          ...groupRightResult,
        });
        setLeftResponsibleGroupRcpt({
          ...leftResponsibleGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "APPROVE") {
        groupRightResult[typeSeq] = rightApproveGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightApproveGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightApproveGroupRcpt({
          ...rightApproveGroupRcpt,
          ...groupRightResult,
        });
        setLeftApproveGroupRcpt({
          ...leftApproveGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "SECONDAPPROVER") {
        groupRightResult[typeSeq] = rightSecondApproveGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightSecondApproveGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightSecondApproveGroupRcpt({
          ...rightSecondApproveGroupRcpt,
          ...groupRightResult,
        });
        setLeftSecondApproveGroupRcpt({
          ...leftSecondApproveGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "THIRDAPPROVER") {
        groupRightResult[typeSeq] = rightThirdApproveGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightThirdApproveGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightThirdApproveGroupRcpt({
          ...rightThirdApproveGroupRcpt,
          ...groupRightResult,
        });
        setLeftThirdApproveGroupRcpt({
          ...leftThirdApproveGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "CONSULTANT") {
        groupRightResult[typeSeq] = rightConsultantGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightConsultantGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightConsultantGroupRcpt({
          ...rightConsultantGroupRcpt,
          ...groupRightResult,
        });
        setLeftConsultantGroupRcpt({
          ...leftConsultantGroupRcpt,
          ...groupLeftResult,
        });
      } else if (recipientType === "ARCHITECT") {
        groupRightResult[typeSeq] = rightArchitectGroupRcpt[typeSeq].filter(
          (rec) => rec.group_seq !== removeRec.group_seq
        );
        groupLeftResult[typeSeq].push(
          ...rightArchitectGroupRcpt[typeSeq].filter(
            (rec) => rec.group_seq === removeRec.group_seq
          )
        );

        setRightArchitectGroupRcpt({
          ...rightArchitectGroupRcpt,
          ...groupRightResult,
        });
        setLeftArchitectGroupRcpt({
          ...leftArchitectGroupRcpt,
          ...groupLeftResult,
        });
      }
    }
  };

  const cancelandBackAction = () => {
    // console.log(submissionValue);
    confirmDialogHandleOpen({
      dialogTitle: "",
      dialogContent:
        "Are you sure want to cancel and back? Any changes made will be unsaved",
      confirmAction: () => cancelandBack(),
      cancelAction: confirmDialogHandleClose,
    });
  };

  const cancelandBack = () => {
    setOpenDialog(false);
    if (isNew) {
      setTabValue(0);
    }
  };

  const downloadFileAction = (fileCat, fileSeq) => {
    fileDownload(fileCat, fileSeq).then((res) => {
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Document Submission");
      console.log("Message: File download successful.");
      console.log(
        "*****************************************************************************"
      );
    });
  };

  const annotationSaveActionHandleOpen = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Annotation Save",
      dialogContent: "Are you sure to save the annotation.",
      confirmAction: annotationSaveAction,
      cancelAction: annotationSaveActionHandleClose,
    });
  };

  let fileAttachmentPreviewDialogBtn = [];
  let noneditfileAttachmentPreviewDialogBtn = [];
  if (userModulesRedux !== null) {
    userModulesRedux.map((module) => {
      // if (module.path === "/circulation") {
      //   if (module.rights.modifiable || module.rights.administrable) {
      fileAttachmentPreviewDialogBtn = [
        {
          buttonName: "Annotation Save",
          buttonFunction: annotationSaveActionHandleOpen,
          chooseFile: false,
        },
      ];
      //   }
      // }
    });
  }

  const annotationSaveActionHandleClose = () => {
    confirmDialogHandleClose();
  };

  const annotationSaveAction = () => {
    webViewerSaveAnnotation(
      filePreviewProperty.fileCategory,
      filePreviewProperty.fileSequence
    ).then((res) => {
      annotationSaveActionHandleClose();

      if (res.type === "success") {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The Annotation have been save",
        });
      } else {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "error",
          title: "Error Alert",
          content: res.message,
        });
      }
    });
  };

  // Input Validation
  const validate = (fieldValues = submissionValue) => {
    let temp = { ...validationErrors };

    if ("location" in fieldValues) {
      temp.location = fieldValues.location ? "" : "This field is required";
    }
    if ("drawing_ref" in fieldValues) {
      temp.drawing_ref = fieldValues.drawing_ref
        ? ""
        : "This field is required";
    }
    if ("specification" in fieldValues) {
      temp.specification = fieldValues.specification
        ? ""
        : "This field is required";
    }
    if ("subject" in fieldValues) {
      temp.subject = fieldValues.subject ? "" : "This field is required";
    }
    if ("manual_ref_no" in fieldValues) {
      temp.manual_ref_no = fieldValues.manual_ref_no
        ? ""
        : "This field is required";
    }
    if ("content" in fieldValues) {
      temp.content = fieldValues.content ? "" : "This field is required";
    }
    if ("request_date" in fieldValues) {
      temp.request_date = fieldValues.request_date
        ? ""
        : "This field is required";
    }
    if ("anticipated_date" in fieldValues) {
      temp.anticipated_date = fieldValues.anticipated_date
        ? ""
        : "This field is required";
    }
    if ("category" in fieldValues) {
      temp.category =
        fieldValues.category.length > 0 ? "" : "This field is required";
    }
    if (rfiDuplicate === true) {
      temp.manual_ref_no = "Duplicate Reference Number";
    }

    if (
      buildRFIOpen ||
      (isNew && isInternal) ||
      (submissionValue.is_draft === "N" && editable) ||
      (submissionValue.is_draft === "Y" && !isSubCon && !transferRcptDialogOpen)
    ) {
      if ("RESPONSIBLE" in fieldValues.recipients) {
        temp.RESPONSIBLE =
          fieldValues.recipients.RESPONSIBLE.length > 0
            ? ""
            : "This field is required";
      }
      if ("APPROVE" in fieldValues.recipients) {
        temp.APPROVE =
          fieldValues.recipients.APPROVE.length > 0
            ? ""
            : "This field is required";
      }
      if ("CONSULTANT" in fieldValues.recipients) {
        temp.CONSULTANT =
          fieldValues.recipients.CONSULTANT.length > 0
            ? ""
            : "This field is required";
      }
      if ("PM" in fieldValues.recipients) {
        temp.PM =
          fieldValues.recipients.PM.length > 0 ? "" : "This field is required";
      }
    } else {
      if ("TO" in fieldValues.recipients) {
        temp.TO =
          fieldValues.recipients.TO.length > 0 ? "" : "This field is required";
      }
    }
    setValidationErrors({ ...temp });

    if (fieldValues == submissionValue) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  const commentvalidate = (fieldValues = submissionCommentValue) => {
    let temp = { ...commentvalidationErrors };
    if ("rficomment" in fieldValues) {
      temp.rficomment = fieldValues.rficomment ? "" : "This field is required";
    }

    setCommentValidationErrors({ ...temp });
    if (fieldValues == submissionCommentValue) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  const responsevalidate = (fieldValues = submissionResponseValue) => {
    let temp = { ...responsevalidationErrors };

    if ("from" in fieldValues) {
      temp.from = fieldValues.from ? "" : "This field is required";
    }
    if ("companyName" in fieldValues) {
      temp.companyName = fieldValues.companyName
        ? ""
        : "This field is required";
    }
    setResponseValidationErrors({ ...temp });

    if (fieldValues == submissionResponseValue) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  useEffect(() => {
    let data = { ...submissionValue };

    data.messages.dms_property_seqs = propertySeqRedux;

    if (presetSubject !== null) {
      data.circ_subject = presetSubject;
      setCirculationSubject(presetSubject);
    }

    if (presetFiles !== null) {
      data.messages.files.push(...presetFiles);
    }

    setSubmissionValue({ ...submissionValue, ...data });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
  }, [presetSubject, presetFiles]);

  useEffect(() => {
    getUserGroupType().then((res) => {
      setUserGroupType(res.data);
      getUserListAction();
      getGroupListAction(res.data);
    });
  }, []);

  useEffect(() => {
    clearData();
    if (isNew === false) {
      getDetailsShowLoading();
      getGroupListShowLoading();
      const fetchRFIAction = async () => {
        const details = await getRFIDetail();
        let insertStageBody = {
          rfi_seq: rfiSeq,
          stage_seq: details.stage_seq,
          rcptBody: details.my_rcpt_type,
        };
        if (details.is_draft === "Y") {
          getDetailsHiddenLoading();
        }
        // Set Readed RFI of the Users
        await insertStageAction(insertStageBody);

        if (details.is_draft === "N") {
          if (details.draftResponses && details.draftResponses.length > 0) {
            for (const draftresponse of details.draftResponses) {
              let obj = { ...draftResponsevalidationErrors };
              obj[draftresponse.response_seq] = {};
              setdraftResponsevalidationErrors({
                ...draftResponsevalidationErrors,
                ...obj,
              });
            }
          }

          // Map the stage control of user

          const stagelist = await getRfiStageList(details.stage_seq);
          let data = { ...userStageAction };

          for (let i = 0; i < details.my_rcpt_type.length; i++) {
            for (let [key, value] of Object.entries(data)) {
              let recipient_type = details.my_rcpt_type[i]["rcpt_category"];
              if (details.my_rcpt_type[i]["rcpt_category"] === "ARCHITECT") {
                recipient_type = "CONSULTANT";
              }
              if (
                details.my_rcpt_type[i]["rcpt_category"] === "ISSUER" ||
                details.my_rcpt_type[i]["rcpt_category"] === "TO"
              ) {
                recipient_type = "RESPONSIBLE";
              }
              if (details.my_rcpt_type[i]["rcpt_category"] !== "TO") {
                if (value !== "Y") {
                  if (key === "IS_ATTACHMENT_READABLE") {
                    data[key] = details.my_rcpt_type[i]["attachment_readable"];
                  } else {
                    let keyToLower = key.toLowerCase();
                    data[key] = stagelist.data.stageList.filter(
                      (obj) =>
                        obj.stage_name === details.stageName &&
                        obj.rcpt_type === recipient_type
                    )[0][keyToLower];
                  }
                } else {
                  data[key] = "Y";
                }
              }
            }
            setUserStageAction({ ...userStageAction, ...data });
          }
          getDetailsHiddenLoading();
        }
        setLoadingFinish(true);
      };
      getGroupListHiddenLoading();

      fetchRFIAction();
    }
  }, [setUserStageAction]);

  return (
    <Fragment>
      {updateDetailsLoading}
      {getDetailsLoading}
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <FullScreenDialog
        open={fileManagerDialogOpen}
        dialogTitle={"File Choice From eFiling "}
        formContent={
          <Efiling fileManagerType={"select"} /> // main => Main File Manager, select => Select File From File Manager
        }
        button={fileManagerDialogBtn}
        handleClose={fileManagerDialogHandleClose}
      />
      <FullScreenDialog
        open={draftfileManagerDialogOpen}
        dialogTitle={"File Choice From eFiling"}
        formContent={
          <Efiling fileManagerType={"select"} /> // main => Main File Manager, select => Select File From File Manager
        }
        button={draftfileManagerDialogBtn}
        handleClose={draftfileManagerDialogHandleClose}
      />
      <FullScreenDialog
        open={filePreviewDialogOpen}
        dialogTitle={"RFI Attachment File Preview"}
        formContent={<FilePreview filePreviewProperty={filePreviewProperty} />}
        button={fileAttachmentPreviewDialogBtn}
        handleClose={filePreviewDialogHandleClose}
      />

      <FullScreenDialog
        open={noneditfilePreviewDialogOpen}
        dialogTitle={"RFI Attachment File Preview"}
        formContent={
          <WebViewer
            property={webViewProps} // Pass the parameter to display document in Viewer.  Parameters => {file_cat: integer, file_ref: integer, file_name: String, autoLoading: Boolean} or null
            readOnly={true} // Hide all annotation tools.  Parameters => Boolean
            zoom={false} // Zoom the document.  Parameters => integer (Percentage) or false
            move={false} // Scroll the view area of document to X Y.  Parameters => {x: integer, y: integer} or false
            ocr={false} // Display OCR Button on Viewer.  Parameters => Boolean
          />
        }
        button={noneditfileAttachmentPreviewDialogBtn}
        handleClose={noneditfilePreviewDialogHandleClose}

        // annotationChangeAlert={annotationChangeAlert}
      />

      <SaveWarnDialog
        open={saveWarnDialogOpen}
        dialogTitle={saveWarnDialogData.dialogTitle}
        dialogContent={saveWarnDialogData.dialogContent}
        saveAction={saveWarnDialogData.saveAction}
        dontSaveAction={saveWarnDialogData.dontSaveAction}
        cancelAction={saveWarnDialogData.cancelAction}
      />
      <NormalDialog
        open={selectUserDialogOpen}
        dialogTitle={`Select ${dialogName} Recipient`}
        formContent={
          <RFIRecipientForm
            submissionValue={submissionValue}
            recipientType={recipientType}
            userGroupType={userGroupType}
            internalOnly={internalOnly}
            getUserListLoading={getUserListLoading}
            getGroupListLoading={getGroupListLoading}
            internalUserList={internalUserList}
            externalUserList={externalUserList}
            userGroupList={userGroupList}
            reciptentChipAdd={reciptentChipAdd}
            reciptentChipRemove={reciptentChipRemove}
            leftCcUserRcpt={leftCcUserRcpt}
            setLeftCcUserRcpt={setLeftCcUserRcpt}
            rightCcUserRcpt={rightCcUserRcpt}
            setRightCcUserRcpt={setRightCcUserRcpt}
            leftCcGroupRcpt={leftCcGroupRcpt}
            setLeftCcGroupRcpt={setLeftCcGroupRcpt}
            rightCcGroupRcpt={rightCcGroupRcpt}
            setRightCcGroupRcpt={setRightCcGroupRcpt}
            leftResponsibleUserRcpt={leftResponsibleUserRcpt}
            setLeftResponsibleUserRcpt={setLeftResponsibleUserRcpt}
            rightResponsibleUserRcpt={rightResponsibleUserRcpt}
            setRightResponsibleUserRcpt={setRightResponsibleUserRcpt}
            leftResponsibleGroupRcpt={leftResponsibleGroupRcpt}
            setLeftResponsibleGroupRcpt={setLeftResponsibleGroupRcpt}
            rightResponsibleGroupRcpt={rightResponsibleGroupRcpt}
            setRightResponsibleGroupRcpt={setRightResponsibleGroupRcpt}
            leftApproveUserRcpt={leftApproveUserRcpt}
            setLeftApproveUserRcpt={setLeftApproveUserRcpt}
            rightApproveUserRcpt={rightApproveUserRcpt}
            setRightApproveUserRcpt={setRightApproveUserRcpt}
            leftApproveGroupRcpt={leftApproveGroupRcpt}
            setLeftApproveGroupRcpt={setLeftApproveGroupRcpt}
            rightApproveGroupRcpt={rightApproveGroupRcpt}
            setRightApproveGroupRcpt={setRightApproveGroupRcpt}
            leftSecondApproveUserRcpt={leftSecondApproveUserRcpt}
            setLeftSecondApproveUserRcpt={setLeftSecondApproveUserRcpt}
            rightSecondApproveUserRcpt={rightSecondApproveUserRcpt}
            setRightSecondApproveUserRcpt={setRightSecondApproveUserRcpt}
            leftSecondApproveGroupRcpt={leftSecondApproveGroupRcpt}
            setLeftSecondApproveGroupRcpt={setLeftSecondApproveGroupRcpt}
            rightSecondApproveGroupRcpt={rightSecondApproveGroupRcpt}
            setRightSecondApproveGroupRcpt={setRightSecondApproveGroupRcpt}
            leftThirdApproveUserRcpt={leftThirdApproveUserRcpt}
            setLeftThirdApproveUserRcpt={setLeftThirdApproveUserRcpt}
            rightThirdApproveUserRcpt={rightThirdApproveUserRcpt}
            setRightThirdApproveUserRcpt={setRightThirdApproveUserRcpt}
            leftThirdApproveGroupRcpt={leftThirdApproveGroupRcpt}
            setLeftThirdApproveGroupRcpt={setLeftThirdApproveGroupRcpt}
            rightThirdApproveGroupRcpt={rightThirdApproveGroupRcpt}
            setRightThirdApproveGroupRcpt={setRightThirdApproveGroupRcpt}
            leftConsultantUserRcpt={leftConsultantUserRcpt}
            setLeftConsultantUserRcpt={setLeftConsultantUserRcpt}
            rightConsultantUserRcpt={rightConsultantUserRcpt}
            setRightConsultantUserRcpt={setRightConsultantUserRcpt}
            leftConsultantGroupRcpt={leftConsultantGroupRcpt}
            setLeftConsultantGroupRcpt={setLeftConsultantGroupRcpt}
            rightConsultantGroupRcpt={rightConsultantGroupRcpt}
            setRightConsultantGroupRcpt={setRightConsultantGroupRcpt}
            leftArchitectUserRcpt={leftArchitectUserRcpt}
            setLeftArchitectUserRcpt={setLeftArchitectUserRcpt}
            rightArchitectUserRcpt={rightArchitectUserRcpt}
            setRightArchitectUserRcpt={setRightArchitectUserRcpt}
            leftArchitectGroupRcpt={leftArchitectGroupRcpt}
            setLeftArchitectGroupRcpt={setLeftArchitectGroupRcpt}
            rightArchitectGroupRcpt={rightArchitectGroupRcpt}
            setRightArchitectGroupRcpt={setRightArchitectGroupRcpt}
            leftToUserRcpt={leftToUserRcpt}
            setLeftToUserRcpt={setLeftToUserRcpt}
            rightToUserRcpt={rightToUserRcpt}
            setRightToUserRcpt={setRightToUserRcpt}
            leftToGroupRcpt={leftToGroupRcpt}
            setLeftToGroupRcpt={setLeftToGroupRcpt}
            rightToGroupRcpt={rightToGroupRcpt}
            setRightToGroupRcpt={setRightToGroupRcpt}
            leftPMUserRcpt={leftPMUserRcpt}
            setLeftPMUserRcpt={setLeftPMUserRcpt}
            rightPMUserRcpt={rightPMUserRcpt}
            setRightPMUserRcpt={setRightPMUserRcpt}
            leftPMGroupRcpt={leftPMGroupRcpt}
            setLeftPMGroupRcpt={setLeftPMGroupRcpt}
            rightPMGroupRcpt={rightPMGroupRcpt}
            setRightPMGroupRcpt={setRightPMGroupRcpt}
          />
        }
        // xs = extraSmall, sm = small, md = medium, lg = large, xl = extraLarge}
        size={"lg"}
        height={700}
        button={recipientDialogBtn}
        handleClose={selectRcptDialogHandleClose}
      />
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <ToCirculationConfirmDialog
        open={rfiToCirculateDialogOpen}
        type={"fromRFI"}
        dialogTitle={rfiToCirculateDialogData.dialogTitle}
        dialogContent={rfiToCirculateDialogData.dialogContent}
        rfi_seq={rfiToCirculateDialogData.rfi_seq}
        ref_no={rfiToCirculateDialogData.ref_no}
        buildAlert={buildAlert}
        circulationHandleClose={circulationHandleClose}
        transmittal={rfiToCirculateDialogData.transmittal}
        confirmAction={rfiToCirculateDialogData.confirmAction}
        cancelAction={rfiToCirculateDialogData.cancelAction}
        confirmDialogHandleClose={rfiToCirculateDialogHandleClose}
      />
      <ReturnCommentDialog
        open={returnCommentDialogOpen}
        rfi_seq={returnCommentDialogData.rfi_seq}
        my_rcpt_type={returnCommentDialogData.my_rcpt_type}
        stageCode={returnCommentDialogData.stageCode}
        setOpenDialog={setOpenDialog}
        dialogTitle={returnCommentDialogData.dialogTitle}
        dialogContent={returnCommentDialogData.dialogContent}
        returnCommentAction={returnCommentDialogData.commentAction}
        returnCommentDialogHandleClose={returnCommentDialogHandleClose}
        cancelAction={returnCommentDialogData.cancelAction}
        buildAlert={buildAlert}
      />

      {(loadingFinish || isNew) && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={classes.detailInformation}>
              <div>
                <div className={classes.itemRoot}>
                  {!isNew && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          RFI Stage:
                          <div className={classes.itemText}>
                            {submissionValue.stageName}
                          </div>
                        </Typography>
                      </Grid>
                      {/* <Grid item xs={12}>
                        <Typography variant="h6">
                          RFI Reference Number:
                          <div className={classes.itemText}>
                            {submissionValue.ref_no}
                          </div>
                        </Typography>
                        <hr className={classes.elementDivider} />
                      </Grid> */}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          Issued By:
                          <div className={classes.itemText}>
                            {submissionValue.createuser}
                          </div>
                        </Typography>
                      </Grid>
                    </>
                  )}

                  <Grid>
                    <RFIAssignList
                      selectRcptDialogHandleOpen={selectRcptDialogHandleOpen}
                      handleRecipientClipClick={handleRecipientClipClick}
                      handleRecipientClipClose={handleRecipientClipClose}
                      removeRecipientAction={removeRecipientAction}
                      internalOnly={internalOnly}
                      anchorEl={anchorEl}
                      openPopoverId={openPopoverId}
                      setSubmissionValue={setSubmissionValue}
                      submissionValue={submissionValue}
                      setSubmissionValie={setSubmissionValue}
                      validationErrors={validationErrors}
                      transferRcptDialogOpen={transferRcptDialogOpen}
                      buildRFIOpen={buildRFIOpen}
                      editable={editable}
                      isNew={isNew}
                      emailErrors={emailErrors}
                      setEmailErrors={setEmailErrors}
                    />
                  </Grid>
                  {(userStageAction.IS_DETAIL_READABLE === "Y" ||
                    submissionValue.is_draft === "Y") && (
                    <Grid>
                      <RFIMaster
                        fileUploadAction={fileUploadAction}
                        removeFileConfirmAction={removeFileConfirmAction}
                        viewFileAction={viewFileAction}
                        noneditViewFileAction={noneditViewFileAction}
                        openFileManagerDialog={fileManagerDialogHandleOpen}
                        downloadFileAction={downloadFileAction}
                        submissionValue={submissionValue}
                        setSubmissionValue={setSubmissionValue}
                        contentEditorValue={contentEditorValue}
                        setContentEditorValue={setContentEditorValue}
                        validate={validate}
                        validationErrors={validationErrors}
                        editable={editable}
                        isNew={isNew}
                        setRfiDuplicate={setRfiDuplicate}
                        rfiDuplicate={rfiDuplicate}
                        userStageAction={userStageAction}
                      />
                    </Grid>
                  )}

                  {!isSubCon && submissionValue.is_draft === "N" && (
                    <div>
                      {userStageAction.IS_COMMENT_READABLE === "Y" && (
                        <Grid>
                          <RFIComment
                            rfi_seq={rfiSeq}
                            postCommentConfirmAction={postCommentConfirmAction}
                            submissionValue={submissionValue}
                            submissionCommentValue={submissionCommentValue}
                            setSubmissionCommentValue={
                              setSubmissionCommentValue
                            }
                            viewFileAction={viewFileAction}
                            noneditViewFileAction={noneditViewFileAction}
                            downloadFileAction={downloadFileAction}
                            commentvalidate={commentvalidate}
                            commentvalidationErrors={commentvalidationErrors}
                            userStageAction={userStageAction}
                          />
                        </Grid>
                      )}

                      {submissionValue.returnComments &&
                        submissionValue.returnComments.length > 0 &&
                        userStageAction.IS_RETURNCOMMENT_READABLE === "Y" && (
                          <Grid>
                            <RFIReturnComment
                              rfi_seq={rfiSeq}
                              submissionValue={submissionValue}
                              submissionCommentValue={submissionCommentValue}
                              setSubmissionCommentValue={
                                setSubmissionCommentValue
                              }
                              userStageAction={userStageAction}
                            />
                          </Grid>
                        )}

                      {userStageAction.IS_RESPONSE_READABLE === "Y" && (
                        <>
                          <Grid>
                            <RFIResponseHistory
                              rfi_seq={rfiSeq}
                              submissionValue={submissionValue}
                              reponseHistoryValue={reponseHistoryValue}
                              setResponseHistoryValue={setResponseHistoryValue}
                              userStageAction={userStageAction}
                              setSubmissionValue={setSubmissionValue}
                              downloadFileAction={downloadFileAction}
                              noneditViewFileAction={noneditViewFileAction}
                              viewFileAction={viewFileAction}
                              getDetailsShowLoading={getDetailsShowLoading}
                              getDetailsHiddenLoading={getDetailsHiddenLoading}
                              fromRFI={true}
                            />
                          </Grid>
                          {userStageAction.IS_RESPONDABLE === "Y" && (
                            <Grid>
                              <RFIDraftResponse
                                rfi_seq={rfiSeq}
                                submissionValue={submissionValue}
                                setSubmissionValue={setSubmissionValue}
                                removeDraftResponseFileConfirmAction={
                                  removeDraftResponseFileConfirmAction
                                }
                                saveDraftResponsetoDraftAction={
                                  saveDraftResponsetoDraftAction
                                }
                                postDraftResponseConfirmAction={
                                  postDraftResponseConfirmAction
                                }
                                draftResponseFileUploadAction={
                                  draftResponseFileUploadAction
                                }
                                presetDraftResponseFiles={
                                  presetDraftResponseFiles
                                }
                                viewFileAction={viewFileAction}
                                openFileManagerDialog={
                                  draftfileManagerDialogHandleOpen
                                }
                                tmpResponseSeq={tmpResponseSeq}
                                setTmpResponseSeq={setTmpResponseSeq}
                                draftResponsevalidationErrors={
                                  draftResponsevalidationErrors
                                }
                              />
                            </Grid>
                          )}
                        </>
                      )}
                      {userStageAction.IS_RESPONDABLE === "Y" && (
                        <RFIResponse
                          rfi_seq={rfiSeq}
                          responseFileUploadAction={responseFileUploadAction}
                          removeResponseFileConfirmAction={
                            removeResponseFileConfirmAction
                          }
                          viewFileAction={viewFileAction}
                          openFileManagerDialog={fileManagerDialogHandleOpen}
                          postResponseConfirmAction={postResponseConfirmAction}
                          saveResponsetoDraftAction={saveResponsetoDraftAction}
                          submissionResponseValue={submissionResponseValue}
                          setSubmissionResponseValue={
                            setSubmissionResponseValue
                          }
                          responsevalidate={responsevalidate}
                          responsevalidationErrors={responsevalidationErrors}
                          presetResponseFiles={presetResponseFiles}
                        />
                      )}
                    </div>
                  )}
                  <Grid container spacing={1}>
                    <div className={classes.rfibtnGroup}>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.formBtn}
                        onClick={() => {
                          cancelandBackAction();
                        }}
                      >
                        Cancel and Back
                      </Button>
                      {!isNew &&
                        !isSubCon &&
                        submissionValue.is_draft === "Y" &&
                        !transferRcptDialogOpen &&
                        !buildRFIOpen && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => {
                              transferRFIAction();
                            }}
                          >
                            Transfer
                          </Button>
                        )}
                      {!isSubCon &&
                        (transferRcptDialogOpen ||
                          buildRFIOpen ||
                          editable) && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => editRFIConfirmAction(rfiSeq)}
                          >
                            Save
                          </Button>
                        )}
                      {!isNew &&
                        !isSubCon &&
                        submissionValue.is_draft === "Y" &&
                        !transferRcptDialogOpen &&
                        !buildRFIOpen && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => {
                              buildRFIAction();
                            }}
                          >
                            Build RFI
                          </Button>
                        )}

                      {!isSubCon &&
                        submissionValue.is_draft === "N" &&
                        userStageAction.IS_UPDATABLE === "Y" &&
                        !editable && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => {
                              updateRFIAction();
                            }}
                          >
                            Edit
                          </Button>
                        )}
                      {isNew && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            postRFIConfirmAction();
                          }}
                        >
                          Submit
                        </Button>
                      )}

                      {!isNew && !editable && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => {
                              circulateAction();
                            }}
                          >
                            Circulate
                          </Button>

                          {/* <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => {
                              eFilingAction();
                            }}
                          >
                            Save to Efiling
                          </Button> */}
                        </>
                      )}

                      {userStageAction.IS_APPROVABLE === "Y" && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            approveRFIConfirmAction(rfiSeq);
                          }}
                        >
                          Approve
                        </Button>
                      )}
                      {userStageAction.IS_RETURNABLE === "Y" && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            returnRFIConfirmAction(rfiSeq);
                          }}
                        >
                          Return
                        </Button>
                      )}
                      {!isSubCon &&
                        userStageAction.IS_SENDABLE === "Y" &&
                        submissionValue.is_sent === "N" &&
                        submissionValue.is_apv_completed === "Y" && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() =>
                              sendRFIToExternalConfirmAction(rfiSeq)
                            }
                          >
                            Send to External
                          </Button>
                        )}
                      {!isSubCon &&
                        userStageAction.IS_COMPLETABLE === "Y" &&
                        submissionValue.responses &&
                        submissionValue.responses.length > 0 && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.formBtn}
                            onClick={() => {
                              completeRFIConfirmAction(rfiSeq);
                            }}
                          >
                            Set this RFI to Complete
                          </Button>
                        )}
                      {!isSubCon && userStageAction.IS_CLOSABLE === "Y" && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            closeRFIConfirmAction(rfiSeq);
                          }}
                        >
                          Close
                        </Button>
                      )}
                      {userStageAction.IS_VOIDABLE === "Y" && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.formBtn}
                          onClick={() => {
                            voidRFIConfirmAction(rfiSeq);
                          }}
                        >
                          Void
                        </Button>
                      )}
                    </div>
                  </Grid>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
};

export default RFIDetailsForm;
